import { StyledLoadingPlaceholder } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledLoadingCard = styled.div`
  ${StyledLoadingPlaceholder}
  width: 100%;
  height: 73.4rem;
  margin-bottom: 6.4rem;
`;
